import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBlogById } from "../../API/blog";
import { MainLayout } from "../MainLayout";
import { BlogInnerSec1 } from "./BlogInnerSec1";
import { Footer } from "../Footer";
import { getBlogs } from "../../API/blog";

const BlogInner = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  useEffect(() => {
    const fetchBlog = async () => {
      if (!slug || slug === "undefined") return;

      try {
        // 1️⃣ get all blogs
        const allBlogs = await getBlogs();

        // 2️⃣ find blog using slug
        const found = allBlogs.find(b => b.slug === slug);

        if (!found) {
          console.error("No blog found for slug:", slug);
          return;
        }

        // 3️⃣ fetch detail using ID
        const data = await getBlogById(found.id);

        if (data) {
          setBlog({
            id: data.id,
            slug: data.slug,
            title: data.title,
            banner: data.imageUrl,
            desc: data.description,
            content: data.longDescription,

            // ✅ ADD THESE
            tableOfContent: data.tableOfContent,
            recentPosts: data.recentPosts,
          });
        }

      } catch (err) {
        console.error("Blog fetch error:", err);
      }
    };

    fetchBlog();
  }, [slug]);

  if (!blog) {
    return <div style={{ textAlign: "center" }}>Loading...</div>;
  }

  return (
    <>
      <MainLayout
        bgImage={`url("${blog.banner}")`}
        text1={"OUR BLOG"}
        text2={blog.title.toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}
        button={true}
      />
      <BlogInnerSec1 blog={blog} />
      <Footer />
    </>
  );
};

export default BlogInner;